import { Component, OnInit } from '@angular/core';
import { siteSpecificData } from '../../../../environments/site-specific-data'

@Component({
  selector: 'mojo-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  getImageUrl() {
    return siteSpecificData.imageUrlBase + "Contact3.png";
  }
}
